import { render, staticRenderFns } from "./search.vue?vue&type=template&id=854b6f1a&"
import script from "./search.vue?vue&type=script&lang=js&"
export * from "./search.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('854b6f1a')) {
      api.createRecord('854b6f1a', component.options)
    } else {
      api.reload('854b6f1a', component.options)
    }
    module.hot.accept("./search.vue?vue&type=template&id=854b6f1a&", function () {
      api.rerender('854b6f1a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/tickets/partials/search.vue"
export default component.exports